const arrowLeftIcon = {
	path: 'M100.699 27.94q0 1.887-1.887 1.887l-72.726 0l0 13.056q0 1.224-1.122 1.683t-2.04-.306l-22.338-20.4q-.561-.51-.561-1.326t.561-1.377l22.338-20.655q.918-.816 2.04-.306t1.122 1.632l0 13.056l72.726 0q.867 0 1.377.51t.51 1.377l0 11.169z', // @Nolint
	width: 100,
	height: 44.439,
};

const arrowRightIcon = {
	path: 'M0 16.798q0-1.785 1.887-1.887l72.726 0l0-13.056q0-1.224 1.122-1.683t2.04.306l22.338 20.4q1.377 1.377 0 2.754l-22.338 20.604q-.918.867-2.04.357t-1.122-1.683l0-13.056l-72.726 0q-.816 0-1.377-.51-.51-.51-.51-1.377l0-11.169z', // @Nolint
	width: 100,
	height: 44.426,
};

const externalLinkIcon = {
	path: 'M100.352 3.579l0 28.665q0 1.421-1.078 2.499t-2.548 1.078-2.499-1.078l-9.849-9.849-36.505 36.505q-.539.588-1.274.588t-1.274-.588l-6.419-6.37q-.539-.539-.539-1.274t.539-1.323l36.505-36.505-9.849-9.849q-1.078-1.029-1.078-2.499t1.078-2.548 2.548-1.029l28.665 0q1.421-.049 2.499 1.029t1.078 2.548zm-21.511 48.363l0 17.934q-.049 6.713-4.753 11.417t-11.368 4.704l-46.599 0q-6.713 0-11.417-4.753t-4.704-11.368l0-46.599q0-6.664 4.753-11.417t11.368-4.704l39.445 0q.784 0 1.274.49t.49 1.274l0 3.626q0 .784-.49 1.274t-1.274.49l-39.445 0q-3.675 0-6.321 2.646t-2.646 6.321l0 46.599q0 3.675 2.646 6.321t6.321 2.646l46.599 0q3.675 0 6.321-2.646t2.646-6.321l0-17.934q0-.784.49-1.274t1.274-.49l3.626 0q.784 0 1.274.49t.49 1.274z',
	width: 100,
	height: 85.695,
};

const gearIcon = {
	path: 'M1152 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zm512-109v222q0 12-8 23t-20 13l-185 28q-19 54-39 91 35 50 107 138 10 12 10 25t-9 23q-27 37-99 108t-94 71q-12 0-26-9l-138-108q-44 23-91 38-16 136-29 186-7 28-36 28h-222q-14 0-24.5-8.5t-11.5-21.5l-28-184q-49-16-90-37l-141 107q-10 9-25 9-14 0-25-11-126-114-165-168-7-10-7-23 0-12 8-23 15-21 51-66.5t54-70.5q-27-50-41-99l-183-27q-13-2-21-12.5t-8-23.5v-222q0-12 8-23t19-13l186-28q14-46 39-92-40-57-107-138-10-12-10-24 0-10 9-23 26-36 98.5-107.5t94.5-71.5q13 0 26 10l138 107q44-23 91-38 16-136 29-186 7-28 36-28h222q14 0 24.5 8.5t11.5 21.5l28 184q49 16 90 37l142-107q9-9 24-9 13 0 25 10 129 119 165 170 7 8 7 22 0 12-8 23-15 21-51 66.5t-54 70.5q26 50 41 98l183 28q13 2 21 12.5t8 23.5z', // @Nolint
	width: 1792,
	height: 1792,
};

export {
	arrowLeftIcon,
	arrowRightIcon,
	externalLinkIcon,
	gearIcon,
}



// WEBPACK FOOTER //
// ../utils/icons.js